<script setup lang="ts">
import { useI18n } from 'vue-i18n'

const { t } = useI18n()
</script>

<template>
  <div class="receiving-model-skeleton" role="status">
    <span class="sr-only">{{ t('my_wallet.loading') }}</span>
    <div class="skeleton-header">
      <div class="skeleton-title skeleton-shimmer" />
      <div class="skeleton-updated skeleton-shimmer" />
    </div>
    <div class="skeleton-cards">
      <div v-for="card in 3" :key="card" class="skeleton-card">
        <div class="skeleton-chip skeleton-shimmer" />
        <div class="skeleton-line -large skeleton-shimmer" />
        <div class="skeleton-divider" />
        <div v-for="line in 3" :key="line" class="skeleton-line skeleton-shimmer" />
        <div class="skeleton-bar skeleton-shimmer" />
      </div>
    </div>
    <div class="skeleton-section">
      <div class="skeleton-line -medium skeleton-shimmer" />
      <div class="skeleton-panel skeleton-shimmer" />
    </div>
  </div>
</template>

<style scoped lang="scss">
@use '../../styles/skeleton';

.receiving-model-skeleton {
  @apply flex flex-col gap-6 w-full;

  .skeleton-header {
    @apply flex flex-col gap-2;
  }

  .skeleton-title {
    @apply h-7 w-64 rounded-sm;
  }

  .skeleton-updated {
    @apply h-3 w-40 rounded-sm;
  }

  .skeleton-cards {
    @apply grid grid-cols-1 gap-4;

    @screen md:system {
      @apply grid-cols-3;
    }
  }

  .skeleton-card {
    @apply flex flex-col gap-4 p-6 rounded-lg border border-neutral-high-medium;
  }

  .skeleton-chip {
    @apply h-6 w-24 rounded-full;
  }

  .skeleton-line {
    @apply h-4 w-full rounded-sm;

    &.-large {
      @apply h-12;
    }

    &.-medium {
      @apply h-6 w-48;
    }
  }

  .skeleton-divider {
    @apply h-px w-full bg-neutral-high-medium;
  }

  .skeleton-bar {
    @apply h-[10px] w-full rounded-md;
  }

  .skeleton-section {
    @apply flex flex-col gap-4;
  }

  .skeleton-panel {
    @apply h-40 w-full rounded-lg;
  }
}
</style>
